module.exports = __webpack_public_path__ + "static/img/shuizhu.538358d5.png";